import { renderInDocument } from '@spotahome/soyuz/client';

import InstitutionsListContainer from './main';

renderInDocument(InstitutionsListContainer);
